import { ComponentNameEnum, SpmTableFilter, StringMap } from '@/types';

const getItemListFieldConfig = (
  defaultValue = [],
  name: string,
  fields: StringMap,
  buttonLabel: string,
  defaultFilters: SpmTableFilter[] = [],
  enableVariants = false,
) => ({
  componentName: ComponentNameEnum.ITEM_LIST,
  options: {
    defaultValue,
    name,
    fields,
    buttonLabel,
    defaultFilters,
    enableVariants,
  },
});

export default getItemListFieldConfig;
